import {
  Disclaimer,
  Div,
  P,
  Separator,
  TextWithTooltipIcon,
  displayCentsInDollars,
  lightTheme,
} from '@vgrubs/components';
import { PaymentReportLineEntity } from 'components/src/types/api/wallet.types';
import { amountColorByValue } from '../TransactonsStyled';

type Props = {
  /**
   * The whole payout as the backend composed it, rendered top to bottom.
   * Labels arrive ready for display - the provider's own wording on its
   * lines, ours on ours - so nothing here maps or translates them: a
   * provider renaming a line must keep working on its own.
   */
  lines: PaymentReportLineEntity[];
};

/**
 * One line per row, and nothing is summed here. A `Received from ...` row is
 * the subtotal of the rows above it, not another item, so adding the list up
 * would double-count the provider's side. The order total comes from
 * `amount` on the transaction instead.
 */
export const IncomeBreakdown = ({ lines }: Props) => (
  <Div $flex $column $gap="4px">
    {lines.map((line, index) => (
      <div key={`${line.label}-${index}`}>
        <Div $flex $alignCenter $between $gap="16px">
          <TextWithTooltipIcon text={`${line.label}:`} tooltip={line.info} />
          <P $m="0" $noWrap $color={amountColorByValue(line.amount)}>
            {displayCentsInDollars(line.amount)}
          </P>
        </Div>
        {line.note && (
          <Disclaimer $m="2px 0 0" $color={lightTheme.lightGray}>
            {line.note}
          </Disclaimer>
        )}
        {line.divider && <Separator $m="4px 0 0" />}
      </div>
    ))}
  </Div>
);
